import React from "react";
import Spinner from "../../Spinner";
const ApprovalDialogBody = ({msg})  =>
<div className="sign-dialog">
    <div className="sign-dialog--task">
    <div>{msg}</div>
    <Spinner/>
</div>
</div>

export default ApprovalDialogBody;